import React from 'react';
import { MapPin, Phone, Mail, Instagram, Youtube, Facebook } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8" id="contact">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Contact Information */}
          <div>
            <h3 className="text-2xl font-bold mb-6 text-sky-400">Contact</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-sky-400">
                  <MapPin size={20} />
                </div>
                <p>
                  Elyte Fitness<br />
                  85 Nutmeg Rd S<br />
                  South Windsor, CT 06074
                </p>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-sky-400">
                  <Phone size={20} />
                </div>
                <p>(860) 602-8519</p>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-sky-400">
                  <Mail size={20} />
                </div>
                <a href="mailto:olu@elyte-fitness.com" className="hover:text-sky-400 transition">
                  olu@elyte-fitness.com
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-2xl font-bold mb-6 text-sky-400">Quick Links</h3>
            <div className="grid grid-cols-2 gap-2">
              <a href="/about" className="hover:text-sky-400 transition">About Us</a>
              <a href="/#packages" className="hover:text-sky-400 transition">Pricing</a>
              <a href="/#testimonials" className="hover:text-sky-400 transition">Success Stories</a>
              <a href="/blog" className="hover:text-sky-400 transition">Blog</a>
              <a href="/faq" className="hover:text-sky-400 transition">FAQ</a>
              <a href="https://billing.stripe.com/p/login/28o7tJ1h86eR9Ko4gg" target='_blank' className="hover:text-sky-400 transition">Members Portal</a>
              <a href="/#contact" className="hover:text-sky-400 transition">Contact</a>
            </div>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-2xl font-bold mb-6 text-sky-400">Follow Us</h3>
            <p className="mb-4">
              Follow and subscribe to us on social media for free fitness tips:
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.instagram.com/weareelyte" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-white text-gray-900 w-10 h-10 rounded-full flex items-center justify-center hover:bg-sky-400 hover:text-white transition"
                aria-label="Follow us on Instagram"
              >
                <Instagram size={20} />
              </a>
              <a 
                href="https://www.youtube.com/@Weareelyte" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-white text-gray-900 w-10 h-10 rounded-full flex items-center justify-center hover:bg-sky-400 hover:text-white transition"
                aria-label="Subscribe to our YouTube channel"
              >
                <Youtube size={20} />
              </a>
              <a 
                href="https://www.facebook.com/weareelyte" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-white text-gray-900 w-10 h-10 rounded-full flex items-center justify-center hover:bg-sky-400 hover:text-white transition"
                aria-label="Like us on Facebook"
              >
                <Facebook size={20} />
              </a>
              <a 
                href="https://www.tiktok.com/@wearelyte" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-white text-gray-900 w-10 h-10 rounded-full flex items-center justify-center hover:bg-sky-400 hover:text-white transition"
                aria-label="Follow us on TikTok"
              >
                <Mail size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Section with Legal Links */}
        <div className="pt-8 border-t border-gray-700 text-sm">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p>&copy; 2025 Elyte Fitness, all rights reserved.</p>
            <div className="flex flex-wrap gap-4 mt-4 md:mt-0">
              <a href="/terms" className="text-gray-400 hover:text-sky-400 transition">Terms & Conditions</a>
              <a href="/privacy-policy" className="text-gray-400 hover:text-sky-400 transition">Privacy Policy</a>
              <a href="/refund-policy" className="text-gray-400 hover:text-sky-400 transition">Refund Policy</a>
            </div>
          </div>
          
          <p className="mt-6 text-xs text-gray-500">
            This site is not a part of the YouTube, Bing, Google, TikTok or Facebook website; Google Inc, Microsoft INC or Meta Inc. Additionally, This site is NOT endorsed by YouTube, Google, Bing, TikTok or Facebook in any way. FACEBOOK is a trademark of FACEBOOK, Inc. YOUTUBE is a trademark of GOOGLE Inc. BING is a trademark of MICROSOFT Inc. TIKTOK is a trademark of ByteDance Ltd.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;